/**
 * @desc  导出 Excle 文件 —— 兼容IE11+
 * @param data { File | Blob } File对象 / Blob流
 * @param name 文件名称
 */
export function exportXlsx(data, name) {
  const blob = new Blob([data]);
  const fileName = name; //下载文件名称

  if (window.navigator.msSaveBlob) {
    // 兼容IE11+
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    // 其他浏览器下载
    const eLink = document.createElement("a");
    eLink.download = fileName;
    eLink.style.display = "none";
    eLink.href = URL.createObjectURL(blob);
    document.body.appendChild(eLink);
    eLink.click();
    URL.revokeObjectURL(eLink.href); // 释放URL 对象
    document.body.removeChild(eLink);
  }
  // const blob = new Blob([data]);
  // const fileName = name; //下载文件名称
  // const eLink = document.createElement("a");
  // eLink.download = fileName;
  // eLink.style.display = "none";
  // eLink.href = URL.createObjectURL(blob);
  // document.body.appendChild(eLink);
  // eLink.click();
  // URL.revokeObjectURL(eLink.href); // 释放URL 对象
  // document.body.removeChild(eLink);
}
/**
 * @desc  导出 Excle 文件 —— 兼容IE11+
 * @param response
 */
export function exportNewXlsx(response) {
  const { headers = {}, data } = response;
  let fileName = ""; //下载文件名称

  // 根据response header 中的 "content-disposition" 来获取导出文件名称
  if (
    (headers["Content-Disposition"] &&
      headers["Content-Disposition"].indexOf("attachment") > -1) ||
    (headers["content-disposition"] &&
      headers["content-disposition"].indexOf("attachment") > -1)
  ) {
    fileName = (
      headers["content-disposition"] || headers["Content-Disposition"]
    ).split("=")[1];
    // fileName 中包含汉子，需要转义
    fileName = window.decodeURI(fileName);
  }

  const blob = new Blob([data]);

  if (window.navigator.msSaveBlob) {
    // 兼容IE11+
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    // 其他浏览器下载
    const eLink = document.createElement("a");
    eLink.download = fileName;
    eLink.style.display = "none";
    eLink.href = URL.createObjectURL(blob);
    document.body.appendChild(eLink);
    eLink.click();
    URL.revokeObjectURL(eLink.href); // 释放URL 对象
    document.body.removeChild(eLink);
  }
}
